<template>
	<div class="hitchManage mainBox">
		<div class="mainTop disBetween">
			<div class="titleIcon"></div>
			<div class="titleName">故障管理</div>
		</div>
		<div class="mainBot ">
			<div class="itemTitleBox disBetween">
				<div class="disStart">
					<span class="title">故障派单</span>
				</div>
				<div class="icon_add iconBox" @click="itemClick({},5)" title="故障报备"></div>
			</div>
			<div class="BtnBox disBetween">
				<div class="searchBox disBetween">
					<div class="disBetween searchLeft">
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityName" placeholder="请输入社区名称"></el-input>
							<!-- <el-select clearable v-model="searchObj.communityId" allow-create filterable remote
								reserve-keyword placeholder="请输入社区关键词" :remote-method="remoteMethod1"
								@change="changeSelect1">
								<el-option v-for="item in restaurants" :key="item.communityId"
									:label="item.communityName" :value="item.communityId">
								</el-option>
							</el-select> -->
						</div>
						<!-- <div class="myinputBox">
							<el-select clearable v-model="searchObj.communitySiteId" slot="prepend"
								placeholder="请选择充电站">
								<el-option v-for="(item,inx) in stationList" :key="inx" :label="item.communitySiteName"
									:value="item.communitySiteId"></el-option>
							</el-select>
						</div> -->
						<div class="myinputBox">
							<el-input clearable v-model="searchObj.communityEquipment" placeholder="请输入设备编号">
							</el-input>
						</div>
						<div class="myinputBox">
							<el-cascader clearable ref="cascader1"
								:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
								v-model="areaValue" :options="areaList" @change="handleChange($event,1)"
								placeholder="请选择所在地区">
							</el-cascader>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.faultType" slot="prepend" placeholder="请选择故障类型">
								<el-option v-for="(item,inx) in faultTypeList" :key="inx"
									:label="item.paramConfigItemName" :value="item.paramConfigItemId"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-select clearable v-model="searchObj.checkFlag" slot="prepend" placeholder="请选择处理状态">
								<el-option v-for="(item,inx) in operateStatusList" :key="inx" :label="item.text"
									:value="item.value"></el-option>
							</el-select>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker  v-model="searchObj.startTime" value-format="yyyy-MM-dd" type="date"
								placeholder="开始时间">
							</el-date-picker>
						</div>
						<div class="myinputBox myinputBox5">
							<el-date-picker v-model="searchObj.endTime" value-format="yyyy-MM-dd" type="date"
								placeholder="结束时间">
							</el-date-picker>	
						</div>
						<el-button type="success" @click="toSearch">查询</el-button>
					</div>
					<!-- <el-button type="success">导出</el-button> -->
				</div>

			</div>
			<div class="listBox">
				<div style="height: 100%;width: 100%;" v-loading="loading">
					<div class="content myTable">
						<el-table :data="tableData" stripe style="width: 100%">
							<el-table-column type="index" label="序号" width="45" fixed>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityEquipmentNo" width="90" label="设备编号">
							</el-table-column>
							<!-- <el-table-column show-overflow-tooltip prop="communitySiteName" width="80" label="所属站点">
							</el-table-column> -->
							<el-table-column show-overflow-tooltip prop="communityName" width="100" label="所属社区">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="communityName" label="所属地区">
								<template slot-scope="scope">
									{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}
								</template>
							</el-table-column>
							<el-table-column prop="dispatchTime" label="故障时间" width="140">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="faultType" label="故障类型" width="90">
							</el-table-column>
							<el-table-column prop="dispatchTime" label="派单时间" width="140">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserName" width="80"
								label="运维人员"></el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserPhone" label="联系方式" width="100">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="orderStatus" width="120" label="处理状态">
								<template slot-scope="scope">
									<span v-if="scope.row.finishFlag==2">已完成</span>
									<span v-else>{{getStatus(scope.row.checkFlag,operateStatusList)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" fixed="right" width="150">
								<template slot-scope="scope">
									<el-button type="text" size="small" @click="itemClick(scope.row,2)">详情</el-button>
									<template v-if="scope.row.finishFlag==1">
										<el-button type="text" v-if="scope.row.checkFlag==-1" size="small"
											@click="itemClick(scope.row,1)">派单</el-button>
										<el-button type="text" v-if="scope.row.checkFlag==5" size="small"
											@click="itemClick(scope.row,1)">重新派单</el-button>
										<el-button type="text" v-if="scope.row.checkFlag==1" size="small"
											@click="itemClick(scope.row,3)">结算审核</el-button>
										<el-button type="text" v-if="scope.row.checkFlag==0" size="small"
											@click="itemClick(scope.row,4)">工单处理</el-button>
									</template>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination  mypagination">
						<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
							:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
							layout="total, prev, pager, next,jumper" ref="pagination"
							@current-change="handleCurrentChange($event,1)">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<el-dialog title="工单详情" center class="mydialog" :visible.sync="dialogVisible1" width="60%">
			<div class="dialogBox ">
				<div class="titleBox">故障设备信息</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>设备名称：{{diaObj.communityEquipmentName}}</span>
						<span>社区名称：{{diaObj.communityName}}</span>
						<span>充电桩名称：{{diaObj.communitySiteName}}</span>
					</div>
					<div class="itemBox ">
						<span>省市区具体地址：{{diaObj.provinceName||''}}{{diaObj.cityName?'/'+diaObj.cityName:''}}{{diaObj.areaName?'/'+diaObj.areaName:''}}</span>
					</div>
					<div class="itemBox itemBox1 disStart">
						<span>故障时间：{{diaObj.faultTime}}</span>
						<span>故障类型：{{diaObj.faultType}}</span>
					</div>
				</div>
				<div class="titleBox">派单信息 <span>本单预估检修费用：{{diaObj.orderFees||"-"}}元</span></div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>运维人员名称：{{diaObj.repairUserName}}</span>
						<span>联系方式：{{diaObj.repairUserPhone}}</span>
						<span>运维区域：{{diaObj.communityName||''}}{{diaObj.communitySiteName?'-'+diaObj.communitySiteName:''}}{{diaObj.communitySiteAddress?'-'+diaObj.communitySiteAddress:''}}{{diaObj.communityEquipmentName?'-'+diaObj.communityEquipmentName:''}}</span>
					</div>
					<div class="itemBox itemBox1 disStart">
						<span>故障状态：{{diaObj.orderStatus==1?'待处理':diaObj.orderStatus==2?'已处理':''}}</span>
						<span>处理时间：{{diaObj.dealTime}}</span>
						<span>处理结果：{{getStatus(diaObj.checkFlag,operateStatusList)}}</span>
					</div>
				</div>
				<div class="contBox">
					<div class="itemBox itemBox2 ">
						<span>现场图片：</span>
						<div class="imgBox disStart" v-if="diaObj.fileUrl">
							<img :src="imgUrl+diaObj.fileUrl">
						</div>
					</div>
				</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>故障描述：{{diaObj.faultDescription}}</span>
					</div>
				</div>
				<div class="titleBox">审核信息</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>审核结果：{{diaObj.checkFlag==5?'审核不通过':(diaObj.orderStatus==3||diaObj.orderStatus==4)?'审核通过':''}}</span>
					</div>
				</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>审核说明：{{diaObj.checkConten}}</span>
					</div>
				</div>
				<div class="contBox">
					<div class="itemBox itemBox1 disStart">
						<span>本单实际检修费用：{{diaObj.realOrderFees||"-"}}元</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer diabtnBox">
				<!-- <el-button @click="dialogVisible1 = false">取 消</el-button> -->
				<el-button type="primary" @click="dialogVisible1 = false">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="故障派单信息" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogVisible2"
			width="60%">
			<el-form :model="repairObj" :rules="rules2" ref="ruleForm2" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox dialogBox2">
					<div class="disBetween">
						<div class="leftBox">
							<div class="titleBox">故障设备信息</div>
							<div class="contBox">
								{{diaObj.provinceName||""}}{{diaObj.cityName||""}}{{diaObj.areaName||""}}——{{diaObj.communityName||""}}——{{diaObj.communitySiteName||""}}——{{diaObj.communityEquipmentName||""}}
								({{diaObj.faultType}})
							</div>
							<div class="titleBox">本单检修费用预估</div>
							<div class="diaItem2 disStart">
								<el-form-item class="lableBox" label="" prop="status">
									<div class="myinputBox">
										<el-select clearable v-model="repairObj.status" slot="prepend">
											<el-option v-for="(item,inx) in orderFeesList" :key="inx"
												:label="item.label" :value="item.value"></el-option>
										</el-select>
									</div>
								</el-form-item>
								<el-form-item class="lableBox" label="" prop="orderFees" v-if="repairObj.status==1">
									<div class="myinputBox">
										<el-input clearable v-model="repairObj.orderFees" placeholder="请输入本单检修费用预估">
										</el-input>
									</div>
								</el-form-item>
							</div>
							<div class="titleBox">选择维修人员</div>
						</div>
						<div class="rightBox" v-if="diaObj.checkFlag==5">
							<div class="rightitemBox">上次检修人员:{{diaObj.repairUserName}}</div>
							<div class="rightitemBox disBetween">
								<div>{{diaObj.dealTime}}</div>
								<div>无法解决</div>
							</div>
							<div class="rightitemBox">结算金额:{{diaObj.orderFees}}元</div>
						</div>
					</div>

					<div class="diaItem disBetween">
						<div class="myinputBox">
							<el-select clearable v-model="repairObj.repairUserName" slot="prepend" allow-create
								filterable remote reserve-keyword :remote-method="remoteMethod2" @change="changeSelect2"
								placeholder="请输入巡检人员名称" :loading="loading3">
								<el-option v-for="(item,inx) in personList" :key="inx" :label="item.repairUserName"
									:value="item.repairUserName"></el-option>
							</el-select>
						</div>
						<div class="myinputBox">
							<el-cascader clearable ref="cascader1"
								:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}"
								v-model="areaValue" :options="areaList" @change="handleChange($event,2)">
							</el-cascader>
						</div>
						<el-button type="success" @click="getoperationData">查询</el-button>
					</div>
					<div class="myTable myTable2" v-loading="loading2">
						<el-table :data="operationData" style="width: 100%" @row-click="singleElection">
							<el-table-column align="center" width="55" label="选择">
								<template slot-scope="scope">
									<!-- 可以手动的修改label的值，从而控制选择哪一项 -->
									<el-radio class="radio" v-model="templateSelection"
										:label="scope.row.repairUserId">&nbsp;
									</el-radio>
								</template>
							</el-table-column>
							<el-table-column type="index" label="序号" width="70">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserName" label="检修人员">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="repairUserPhone" label="联系方式">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="value4" label="管辖地区" width="180">
								<template slot-scope="scope">
									<span>{{scope.row.provinceName||""}}{{scope.row.cityName||""}}{{scope.row.areaName||""}}</span>
								</template>
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="totalCount" label="本月已接单">
							</el-table-column>
							<el-table-column show-overflow-tooltip prop="finishCount" label="待处理">
							</el-table-column>
						</el-table>
					</div>
					<!-- <div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange($event,2)">
					</el-pagination>
				</div> -->
					<div slot="footer" class="dialog-footer diabtnBox disAround">
						<el-button @click="dialogVisible2 = false">取 消</el-button>
						<el-button type="primary" @click="torepair('ruleForm2')">确 定</el-button>
					</div>
				</div>
			</el-form>
		</el-dialog>
		<el-dialog title="结算审核" center class="mydialog" :visible.sync="dialogVisible3" width="60%">
			<el-form :model="diaObj" :rules="rules" ref="ruleForm1" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox dialogBox3">

					<div class="contBox">
						<div class="itemBox itemBox1 disStart">
							<span>处理结果：{{diaObj.communityEquipmentName}}</span>
						</div>
						<div class="itemBox itemBox2 ">
							<span>现场图片：</span>
							<div class="imgBox disStart">
								<img v-if="diaObj.fileUrl" :src="imgUrl+diaObj.fileUrl">
							</div>
						</div>
						<div class="itemBox itemBox1 disStart">
							<span>故障描述：{{diaObj.faultDescription}}</span>
						</div>
					</div>
					<div class="linBox"></div>
					<div class="contBox">
						<div class="itemBox3 disStart">
							<el-form-item class="lableBox" label="审核结果：" prop="examineStatus">
								<div class="myinputBox">
									<el-select clearable v-model="diaObj.examineStatus" slot="prepend"
										placeholder="请选择审核结果">
										<el-option v-for="(item,inx) in examineList" :key="inx" :label="item.text"
											:value="item.value"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
						<div class="itemBox3 disStart" v-if="diaObj.examineStatus==2">
							<el-form-item class="lableBox" label="审核说明：" prop="illustrate">
								<div class="myinputBox">
									<el-input clearable v-model="diaObj.illustrate" placeholder="请输入审核说明">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div v-if="diaObj.examineStatus==1">
							<div class="itemBox itemBox1 disStart">
								<span>本单检修费用预估：{{diaObj.orderFees}}</span>
							</div>
							<div class="itemBox3 disStart">
								<el-form-item class="lableBox" label="本单实际检修费用：" prop="cost">
									<div class="myinputBox">
										<el-input clearable v-model="diaObj.cost" placeholder="请输入本单实际检修费用">
										</el-input>
									</div>
								</el-form-item>
							</div>
						</div>
					</div>
				</div>
				<!-- <span slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible3 = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible3 = false">确 定</el-button>
			</span> -->
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible3=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm1')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<el-dialog title="工单处理" center class="mydialog" :visible.sync="dialogVisible4" width="60%">
			<div class="dialogBox dialogBox2">
				<el-radio-group v-model="diaObj.dealFlag" size="mini" class="radioBox">
					<el-radio label="1">重新派单（旧工单状态变更为已完成，生成一个新的工单，状态为待派单）</el-radio>
					<el-radio label="2">工单完结（状态变更为已完成）</el-radio>
				</el-radio-group>
			</div>
			<span slot="footer" class="dialog-footer diabtnBox disAround">
				<el-button @click="dialogVisible4 = false">取 消</el-button>
				<el-button type="primary" @click="handle">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="故障报备" center class="mydialog" :visible.sync="dialogVisible5" width="60%">
			<el-form :model="creatFault" :rules="rules" ref="ruleForm3" label-width="100px" class="demo-ruleForm">
				<div class="dialogBox dialogBox3">
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="设备编号" prop="communityEquipmentNo">
								<div class="myinputBox">
									<el-input v-model="creatFault.communityEquipmentNo" placeholder="请输入设备编号">
									</el-input>
								</div>
							</el-form-item>
						</div>
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="故障类型" prop="faultType">
								<div class="myinputBox">
									<el-select clearable v-model="creatFault.faultType" slot="prepend"
										placeholder="请选择故障类型">
										<el-option v-for="(item,inx) in faultTypeList" :key="inx"
											:label="item.paramConfigItemName"
											:value="item.paramConfigItemId"></el-option>
									</el-select>
								</div>
							</el-form-item>
						</div>
					</div>
					<div class="diaItem diaItem2 disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="现场照片">
								<div class="myinputBox">
									<el-upload ref="uploadImg" class="avatar-uploader" :auto-upload="autoUpload"
										:show-file-list="false" :before-upload="beforeUpload" :on-change="getFile"
										action="certmanage" :on-remove="handleRemove" :limit="1"
										:on-exceed="handleExceed">
										<el-image v-if="creatFault.imageUrl" class="avatar" :src="creatFault.imageUrl"
											:preview-src-list="[creatFault.imageUrl]" @click.stop="">

										</el-image>
										<span v-if="creatFault.imageUrl" class="delIcon" @click.stop="delImg"></span>
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</div>
							</el-form-item>
						</div>
					</div>
					<!-- <div class="diaItem2 disBetween">
						
					</div> -->
					<div class="diaItem disBetween">
						<div class="diaTpye disStart">
							<el-form-item class="lableBox" label="故障描述" prop="faultDescription">
								<div class="myinputBox myinputBox4">
									<el-input type="textarea" v-model="creatFault.faultDescription"
										placeholder="请输入故障描述" resize="none"></el-input>
								</div>
							</el-form-item>
						</div>
					</div>
				</div>
				<el-form-item class="diabtnBox disCenter">
					<el-button @click="dialogVisible5=false">取 消</el-button>
					<el-button type="primary" @click="toSave('ruleForm3')">保 存</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	import {
		timestampToDate
	} from "../../../../assets/js/common.js"
	var token = localStorage.getItem('token')
	export default {
		name: "hitchManage",
		components: {},
		data() {
			return {
				headers: {
					Authorization: token,
					token: token
				},
				PageInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				autoUpload: false,
				fileList: [],
				dialogVisible1: false,
				dialogVisible2: false,
				dialogVisible3: false,
				dialogVisible4: false,
				dialogVisible5: false,
				NOfalse: false,
				templateSelection: "",
				diaObj: {
					"orderFaultId": "", //故障id
					"communityEquipmentNo": "", //设备硬件编号
					"communityEquipmentName": "", //设备名
					"communitySiteName": "", //所属站点
					"communityName": "", //所属社区
					"provinceName": "", //省
					"cityName": "", //市
					"areaName": "", //区
					"communitySiteAddress": "", //具体地址
					"faultTime": "", //故障时间
					"faultType": "", //故障类型
					"dispatchTime": "", //派单时间
					"repairUserName": "", //运维人员名称
					"repairUserPhone": "", //联系方式
					"manageProvinceName": "", //运维区域省
					"manageCityName": "", //运维区域市
					"manageAreaName": "", //运维区域区
					"orderStatus": "", //故障状态 1待处理 2已处理
					"dealTime": "" //处理时间
				},
				creatFault: {
					imageUrl: "",
				},
				operationData: [],
				tableData: [],
				stationList: [],
				faultTypeList: [],
				operateStatusList: [{
						text: "待派单",
						value: -1
					},
					{
						text: "未处理",
						value: 0
					},
					{
						text: "已解决 待审核",
						value: 1
					},
					{
						text: "无法解决 待审核",
						value: 2
					},
					{
						text: "已完成",
						value: 3
					},
					{
						text: "未完成",
						value: 4
					},
					{
						text: "审核不通过 待处理",
						value: 5
					}
				],
				orderFeesList: [{
						value: 20.00,
						label: "20.00元",
					},
					{
						value: 40.00,
						label: "40.00元",
					},
					{
						value: 50.00,
						label: "50.00元",
					},
					{
						value: 60.00,
						label: "60.00元",
					},
					{
						value: 80.00,
						label: "80.00元",
					}, {
						value: 100.00,
						label: "100.00元",
					}, {
						value: 1,
						label: "其他"
					}
				],
				examineList: [{
						text: "审核通过",
						value: 1
					},
					{
						text: "审核不通过",
						value: 2
					}
				],
				loading: false,
				loading2: false,
				loading3: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
					communityName: "", //社区名称
					communitySiteName: "", //站点名称
					communityEquipment: "", //设备编号/名称
					orderStatus: '', //处理状态 1待处理 2已完成
					startTime: '', //开始时间
					endTime: '', //结束时间
					searchData: [],
				},
				repairObj: {
					"repairUserName": "", //维修人员
					"manageProvinceNo": "", //省
					"manageCityNo": "", //市
					"manageAreaNo": "" //区
				},
				perSearchObj: {
					pageNo: 1, //当前页
					pageSize: 10, //当前页个数
				},
				OperationInfo: {
					pagesize: 10,
					pagenum: 1,
					total: 0
				},
				restaurants: [],
				options: [],
				options2: [],
				areaValue: '',
				areaList: [],
				personList: [],
				list: [],
				rules2: {
					status: [{
						required: true,
						message: '请选择本单检修费用预估',
						trigger: 'change'
					}],
					orderFees: [{
						required: true,
						message: '请输入本单检修费用预估',
						trigger: 'blur'
					}],
				},
				rules: {
					examineStatus: [{
						required: true,
						message: '请选择审核结果',
						trigger: 'change'
					}],
					illustrate: [{
						required: true,
						message: '请输入审核说明',
						trigger: 'blur'
					}],
					cost: [{
						required: true,
						message: '请输入本单实际检修费用',
						trigger: 'blur'
					}],
					communityEquipmentNo: [{
						required: true,
						message: '请输入设备硬件编号',
						trigger: 'blur'
					}],
					faultType: [{
						required: true,
						message: '请选择故障类型',
						trigger: 'change'
					}],
					faultDescription: [{
						required: true,
						message: '请输入故障描述',
						trigger: 'blur'
					}],
				},
				fd1: new FormData(),
				imgUrl:"image/"
			}
		},
		created() {
			if (process.env.NODE_ENV === "development") {
				this.imgUrl="image/"
			} else {
				this.imgUrl="charge/"
			}
		},
		mounted() {
			if (this.$route.query) {
				this.searchObj.communityEquipment = this.$route.query.communityEquipmentNo
			}
			this.selectParamConfigByCode()
			// let time = new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000
			// this.searchObj.searchData = [timestampToDate(time), timestampToDate(new Date().getTime())]

			this.$nextTick(() => {
				this.getData()
				this.getpersonList()
				if (!(localStorage.getItem("areaList"))) {
					this.getAreaList()
				} else {
					this.$set(this, "areaList", JSON.parse(localStorage.getItem("areaList")))
				}
			})
		},
		methods: {
			delImg() {
				this.$set(this, "fileList", [])
				this.$set(this.creatFault, "imageUrl", "")
				this.$refs.uploadImg.clearFiles()
			},
			handleExceed(files, fileList) {
				this.$message.warning(`已经上传故障照片`);
			},
			getFile(file, fileList) {
				this.fileList = fileList;
				let extName = file.name.substring(file.name.lastIndexOf('.') + 1);
				var AllUpExt = '.png|.PNG|.jpg|.JPG|.jpeg|.JPEG'
				if (AllUpExt.indexOf(extName) === -1) {
					this.$message.error('文件格式不正确!')
					// this.isDisable = true; //校验不正确不允许表单提交
					this.delImg()
				} else {
					console.log(file)
					console.log(this.fileList)
					this.$set(this.creatFault, "imageUrl", URL.createObjectURL(file.raw))
					this.fd1.append('file', file.raw)
				}
			},
			beforeUpload(file) {
				let type = file.name.slice(file.name.lastIndexOf(".") + 1)
				if (type == "png" || type == "PNG" || type == "jpg" || type == "JPG" || type == "jpeg" || type == "JPEG") {

				} else {
					this.$message.warning(`请上传图片格式`);
					reject()
				}
			},
			handleRemove(file, fileList) {
				console.log(file, fileList);
			},
			handle() {
				if (this.diaObj.dealFlag) {
					let obj = {
						orderFaultId: this.diaObj.orderFaultId, //订单id
						dealFlag: this.diaObj.dealFlag //工单处理状态 1重新派单 2工单已完结
					}
					this.$api.dealOrderFaultRepairUser(obj).then((res) => {
						if (res.returnCode == 200) {
							this.dialogVisible4 = false
							this.getData()
						}
					})
				} else {
					that.$message('请对当前工单进行处理');
				}

			},
			toSave(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (formName == "ruleForm3") {
							if (this.fileList.length > 0) {
								this.fd1.append("communityEquipmentNo", this.creatFault.communityEquipmentNo)
								this.fd1.append("faultType", this.creatFault.faultType)
								this.fd1.append("faultDescription", this.creatFault.faultDescription)
								that.$api.addOrderFault(this.fd1).then((res) => {
									if (res.returnCode == 200) {
										that.$nextTick(() => {
											that.dialogVisible5 = false
											that.$message({
												message: '故障报备成功',
												type: 'success'
											});
											setTimeout(() => {
												that.getData()
											}, 500)
										})
									}else if(res.returnCode==11000){
										that.$message({
											message: '设备不存在',
											type:"error"
										});
									}
								})
							} else {
								this.$message({
									message: "请上传故障照片",
									type: 'error'
								});
							}
						} else {
							let obj = {
								orderFaultId: that.diaObj.orderFaultId, //订单id
								checkStatus: that.diaObj.examineStatus, //1审核通过 2审核不通过
								checkContent: that.diaObj.illustrate, //审核不通过内容
								realOrderFees: that.diaObj.cost, //实际订单金额
							}
							this.$api.checkOrderFaultRepairUser(obj).then((res) => {
								if (res.returnCode == 200) {
									this.dialogVisible3 = false
									this.getData()
								}
							})
						}

					} else {
						return false;
					}
				});

			},
			selectParamConfigByCode() {
				this.$api.selectParamConfigByCode({
					"paramCode": 1001,
					"search": ""
				}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "faultTypeList", res.obj.paramConfigItemList)
					}
				})
			},
			singleElection(row) {
				this.templateSelection = row.repairUserId
				this.checkList = this.tableData.filter((item) => item.repairUserId === row.repairUserId)
				console.log(`该行的编号为${ this.templateSelection}`)
			},
			getpersonList() {
				this.$api.listAllOrderRepairUser().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "personList", res.obj)
					}
				})
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
						localStorage.setItem('areaList', JSON.stringify(res.obj))
					}
				})
			},
			itemClick(item, n) {
				let that = this
				this.templateSelection = ''
				if (n != 5) {
					this.$api.selectOrderFault({
						orderFaultId: item.orderFaultId
					}).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "diaObj", res.obj)
						}
					})
				}

				if (n == 1) { //派单
					this.$api.listOrderFaultRepairUser(this.repairObj).then((res) => {
						if (res.returnCode == 200) {
							this.$set(this, "operationData", res.obj)
							this.dialogVisible2 = true
						}
					})
				} else if (n == 2) { //详情
					this.dialogVisible1 = true
				} else if (n == 3) { //结算审核
					this.dialogVisible3 = true
					this.$nextTick(() => {

						this.$refs.ruleForm1.clearValidate()
					})
				} else if (n == 4) { //工单处理
					this.dialogVisible4 = true
				} else if (n == 5) { //故障报备
					this.dialogVisible5 = true
					that.fd1.forEach(function(val, key, fD) {
						// here you can add filtering conditions
						that.fd1.delete(key)
					});
					this.$set(this, "creatFault", {})
					this.$nextTick(() => {
						this.delImg()
						this.$refs.ruleForm3.clearValidate()
					})
				}
			},
			getoperationData() {
				this.$api.listOrderFaultRepairUser(this.repairObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "operationData", res.obj)
						// this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
			},
			remoteMethod1(query) {
				let that = this
				if (query !== '') {
					let searchObj = {
						search: query,
						pageNo: 1, //当前页
						pageSize: 1000, //当
						provinceCode: "", //省级编号
						cityCode: "", //市级编号
						areaCode: "" //区级编号
					}
					that.$api.listCommunityInfo(searchObj).then((res) => {
						if (res.returnCode == 200) {
							that.$set(that, "restaurants", res.obj.list)
							setTimeout(() => {
								that.options = that.restaurants.filter(item => {
									return item.communityName.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);

						}
					})

				} else {
					this.options = [];
				}
			},
			changeSelect1(n) {
				this.$set(this, "stationList", [])
				this.$set(this.searchObj, "communitySiteId", "")
				this.$set(this.searchObj, "communityName", "")
				let item = this.options.find((item, inx) => {
					return item.communityId == n
				})
				if (item) {
					this.$set(this.searchObj, "communityName", item.communityName)
					// if (n) {
					// 	this.$api.listAllCommunitySiteByCommunityId({
					// 		communityId: item.communityId
					// 	}).then((res) => {
					// 		if (res.returnCode == 200) {
					// 			this.$set(this, "stationList", res.obj)
					// 		}
					// 	})
					// }
				} else {
					this.$set(this.searchObj, "communityName", n)
				}

			},
			remoteMethod2(query) {
				if (query !== '') {
					this.loading3 = true;
					setTimeout(() => {
						this.loading3 = false;
						this.options2 = this.list.filter(item => {
							return item.label.toLowerCase()
								.indexOf(query.toLowerCase()) > -1;
						});
					}, 200);
				} else {
					this.options2 = [];
				}
			},
			changeSelect2(n) {},
			getStatus(val, arr) {
				let obj = arr.find((item) => {
					return val == item.value
				}) || {}
				return obj.text || ""
			},
			getName(val, arr) {
				let obj = arr.find((item) => {
					return val == item.paramConfigItemId
				}) || {}
				return obj.paramConfigItemName || ""
			},
			toSearch() {
				this.$set(this.PageInfo,"pagenum",1)
				this.$set(this.searchObj,"pageNo",1)
				this.$nextTick(() => {
					this.getData()
				})
			},
			getData(n) {
				this.loading = true
				this.$api.listOrderFault(this.searchObj).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "tableData", res.obj.list)
						this.$set(this.PageInfo, "total", res.obj.total || 0)
						this.loading = false
					}
				})
			},
			// 选择分页
			handleCurrentChange(val, n) {
				if (n == 1) {
					this.$set(this.PageInfo,"pagenum",val)
					this.$set(this.searchObj,"pageNo",val)
					this.getData({})
				} else {

				}

			},
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					if (n == 1) {
						this.$set(this.searchObj, "provinceCode", nodesInfo[0].path[0] || "")
						this.$set(this.searchObj, "cityCode", nodesInfo[0].path[1] || "")
						this.$set(this.searchObj, "areaCode", nodesInfo[0].path[2] || "")
					} else {
						this.$set(this.repairObj, "manageProvinceNo", "")
						this.$set(this.repairObj, "manageCityNo", "")
						this.$set(this.repairObj, "manageAreaNo", "")
					}
				} else {
					this.$set(this.searchObj, "provinceCode", "")
					this.$set(this.searchObj, "cityCode", "")
					this.$set(this.searchObj, "areaCode", "")
					this.$set(this.repairObj, "manageProvinceNo", "")
					this.$set(this.repairObj, "manageCityNo", "")
					this.$set(this.repairObj, "manageAreaNo", "")
				}
			},
			torepair(formName) {
				let that = this
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!that.templateSelection) {
							that.$message('请选择维修人员');
							return false
						}
						let obj = {
							orderFaultId: that.diaObj.orderFaultId,
							repairUserId: that.templateSelection,
							orderFees: that.repairObj.status == 1 ? that.repairObj.orderFees : that.repairObj
								.status
						}
						that.$api.bindOrderFaultRepairUser(obj).then((res) => {
							if (res.returnCode == 200) {
								that.dialogVisible2 = false
								this.getData()
								// this.$set(this, "operationData", res.obj)
								// this.$set(this.OperationInfo, "total", res.obj.total || 0)
							}
						})
					} else {
						return false;
					}
				});

			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./hitchManage.scss";
</style>